var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Parent_Guardian",
    "data-name": "Parent/Guardian",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.385,
    height: 39.385,
    viewBox: "0 0 39.385 39.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898",
    transform: "translate(0.025 0.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M37.88,19.212l1.709-.906A19.8,19.8,0,0,0,21.652.346l-1.086,1.5L19.3.3a19.711,19.711,0,0,0-19,19l1.606.927L.347,21.651A19.781,19.781,0,0,0,18.284,39.588l1.228-1.748,1.125,1.794a19.724,19.724,0,0,0,19-18.975Z",
    transform: "translate(-0.301 -0.3)",
    fill: "#3e3e3e"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_900",
    "data-name": "Group 900",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_899",
    "data-name": "Group 899",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M39.315,18.031a15.288,15.288,0,0,1-6.054.069l.277-1.062a1.145,1.145,0,1,0-2.215-.577l-.3,1.038a15.178,15.178,0,0,1-2.631-1.246l.623-.877a1.152,1.152,0,1,0-1.892-1.315l-.6.877c-.392-.323-.762-.6-1.131-.946a14.119,14.119,0,0,1-.923-1.131l.854-.6a1.152,1.152,0,1,0-1.315-1.892l-.877.623a15.178,15.178,0,0,1-1.246-2.631l1.061-.3a1.148,1.148,0,1,0-.6-2.215l-1.062.277A15.289,15.289,0,0,1,21.377.069C20.823.023,20.246,0,19.692,0a6.484,6.484,0,0,0-.669.023,17.683,17.683,0,0,0,.046,6.7l-1.2.323a1.148,1.148,0,1,0,.6,2.215l1.2-.3a17.609,17.609,0,0,0,1.569,3.346l-1.015.715a1.152,1.152,0,0,0,1.315,1.892l1.038-.715a13.8,13.8,0,0,0,1.2,1.408,17.771,17.771,0,0,0,1.385,1.246l-.692.992a1.132,1.132,0,0,0,.3,1.592,1.145,1.145,0,0,0,1.592-.277l.692-.992a19.49,19.49,0,0,0,3.369,1.592l-.3,1.154a1.148,1.148,0,1,0,2.215.6l.323-1.154a16.083,16.083,0,0,0,3.323.346,18.4,18.4,0,0,0,3.377-.323c.023-.231.023-.462.023-.692q0-.831-.069-1.661Zm-18.4,12.092-1.2.323a16.568,16.568,0,0,0-1.569-3.369l1.015-.715a1.127,1.127,0,0,0,.277-1.592,1.152,1.152,0,0,0-1.592-.3l-1.015.715a17.8,17.8,0,0,0-1.223-1.408A17.787,17.787,0,0,0,14.2,22.554l.715-1.015a1.152,1.152,0,0,0-1.892-1.315l-.715,1.015a16.571,16.571,0,0,0-3.369-1.569l.323-1.2a1.148,1.148,0,1,0-2.215-.6l-.323,1.2a17.683,17.683,0,0,0-6.7-.046A6.486,6.486,0,0,0,0,19.692c0,.554.023,1.131.069,1.685a15.282,15.282,0,0,1,6.054-.069l-.277,1.038a1.146,1.146,0,0,0,.808,1.408,1.133,1.133,0,0,0,1.408-.831l.3-1.038a15.178,15.178,0,0,1,2.631,1.246l-.623.877a1.171,1.171,0,0,0,.277,1.615,1.152,1.152,0,0,0,1.615-.3l.623-.877c.369.3.738.6,1.108.946.346.346.623.738.946,1.108l-.877.623a1.152,1.152,0,1,0,1.315,1.892l.877-.623A15.178,15.178,0,0,1,17.5,31.023l-1.061.3a1.148,1.148,0,1,0,.6,2.215l1.038-.277a15.282,15.282,0,0,1-.069,6.054c.554.046,1.131.069,1.685.069a6.483,6.483,0,0,0,.669-.023,17.679,17.679,0,0,0-.046-6.7l1.2-.323a1.153,1.153,0,0,0,.808-1.408,1.135,1.135,0,0,0-1.408-.808Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/Position.b03fc9bb584d2d8a6db4c0a9b1f11123.svg";
export { ForwardRef as ReactComponent };